module.exports = __webpack_public_path__ + "img/person-lifting-weights.8a4b91a5.svg";